export default __webpack_public_path__ + "static/banner-which-credit-card-is-best-for-you-8fb60fa9d75f8a2995299483474951fa.jpg";